import React from 'react';
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'

const CommitTransactionList = props => {

    if (!props.transactions) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.transactions.length === 0) {
        return (
            <div className='empty'>
                No transactions...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>created</th>
                        <th>sender account</th>
                        <th>recipient account</th>
                        <th>amount</th>
                        <th>fee</th>
                        <th>hash</th>
                        <th>status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.transactions.map(transaction => {
                            return (
                                <tr key={transaction.key}>
                                    <td>{dateHelper.Formatter.toLocalString(transaction.created)}</td>
                                    <td>{transaction.sender_account}</td>
                                    <td>{transaction.recipient_account}</td>
                                    <td>{numberHelper.Formatter.toDecimal(transaction.amount)}</td>
                                    <td>{transaction.details.transaction_fee}</td>
                                    <td>{transaction.details.transaction_hash}</td>
                                    <td>{transaction.details.transaction_sucess + ''}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CommitTransactionList;



// WEBPACK FOOTER //
// ./src/components/widgets/CommitTransactionList.js